import { useTranslation, useUser, useEffect } from '@/imports-files/common/common';

const LanguageInitializer = ({session}) => {
 const { i18n } = useTranslation();
 const { user, clearUser, updateUser }             =   useUser();

  useEffect(() => {
    let langauge = user?.language_iso_code || session?.language_iso_code || "en"
    if(i18n.language !== langauge){
      i18n.changeLanguage(langauge);
    }
  }, []);

  return null;
};

export default LanguageInitializer;
